import type { Source } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetSources } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useSourcesSWRKey } from "./useSourcesSWRKey"

export function useSources(): SWRResponse<Array<Source>> {
  const sourcesSWRKey = useSourcesSWRKey()
  const getSources = useGetSources()

  const getSourcesData = useMemo(
    () => !getSources ? null : () => getSources({ params: {} }),
    [getSources],
  )

  return useSWR<Array<Source>>(
    sourcesSWRKey,
    getSourcesData,
  )
}
